import * as React from 'react';

interface Props {
    href: string;
    children: string;
    openLinksExternally: boolean;
}

interface State {}

export default class MessageLink extends React.Component<Props, State> {
    /**
     * Determines if the link should open externally. If not
     * `openLinksExternally`, we check to see if the url has the same domain as
     * the current website.
     */
    shouldOpenExternally() {
        if (this.props.openLinksExternally) {
            return true;
        }

        const url = this.props.href.toLowerCase();
        const domain = window.location.hostname.toLowerCase();
        return !url.includes(domain);
    }

    render() {
        return (
            <a href={this.props.href} target={this.shouldOpenExternally() ? '_blank' : '_self'}>
                {this.props.children}
            </a>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/MessageLink.tsx